import Axios from "@/plugins/Axios";

/**
 * Pré-matrícula: períodos (administração), acompanhamento da secretaria e o fluxo público.
 *
 * As rotas de `publico/pre-matriculas` não exigem login. Nenhuma delas recebe id de
 * pré-matrícula: o boleto só volta pela consulta de CPF e data de nascimento.
 */
export class PreMatriculasService {
  // Períodos

  async listarPeriodos(pagina = 1, porPagina = 15) {
    const response = await Axios().get("pre-matricula-periodos", {
      params: { page: pagina, por_pagina: porPagina },
    });
    return response.data;
  }

  async pegarPeriodo(periodoId) {
    const response = await Axios().get(`pre-matricula-periodos/${periodoId}`);
    return response.data;
  }

  async criarPeriodo(periodo) {
    const response = await Axios().post("pre-matricula-periodos", periodo);
    return response.data;
  }

  async atualizarPeriodo(periodoId, periodo) {
    const response = await Axios().put(`pre-matricula-periodos/${periodoId}`, periodo);
    return response.data;
  }

  async alterarSituacaoDoPeriodo(periodoId, ativo) {
    const response = await Axios().patch(`pre-matricula-periodos/${periodoId}/situacao`, {
      ativo,
    });
    return response.data;
  }

  async excluirPeriodo(periodoId) {
    const response = await Axios().delete(`pre-matricula-periodos/${periodoId}`);
    return response.data;
  }

  // Secretaria

  async listar(filtros) {
    const response = await Axios().get("pre-matriculas", { params: filtros });
    return response.data;
  }

  async pegar(preMatriculaId) {
    const response = await Axios().get(`pre-matriculas/${preMatriculaId}`);
    return response.data;
  }

  /** @param {{ substituir_responsavel: boolean, turma_id: number, serie_id: number }} opcoes */
  async efetivar(preMatriculaId, opcoes) {
    const response = await Axios().post(`pre-matriculas/${preMatriculaId}/efetivar`, opcoes);
    return response.data;
  }

  /** Gera o boleto de pré-matrícula pendente que ficou sem boleto. Registra no Sicoob. */
  /**
   * Pagamento recebido na escola; a API dá baixa no boleto do Sicoob.
   * Mesmo corpo de POST parcelas/{id}/baixar: { mensalidades: [{ forma_de_pagamento_id, valor }],
   * juros, multa, desconto }.
   */
  async registrarPagamento(preMatriculaId, baixa) {
    const response = await Axios().post(`pre-matriculas/${preMatriculaId}/pagamento`, baixa);
    return response.data;
  }

  async gerarBoleto(preMatriculaId) {
    const response = await Axios().post(`pre-matriculas/${preMatriculaId}/boleto`);
    return response.data;
  }

  /** Baixa o PDF do boleto da pré-matrícula, pela rota interna da secretaria. */
  async baixarBoleto(preMatriculaId) {
    const response = await Axios().get(`pre-matriculas/${preMatriculaId}/boleto`, {
      responseType: "arraybuffer",
    });
    const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
    const link = document.createElement("a");
    link.href = url;
    link.download = `boleto-pre-matricula-${preMatriculaId}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }

  // Fluxo público

  async periodoVigente() {
    const response = await Axios().get("publico/pre-matriculas/periodo-vigente");
    return response.data;
  }

  async consultarCpf(cpf, dataNascimento) {
    const response = await Axios().post("publico/pre-matriculas/consultar-cpf", {
      cpf,
      data_nascimento: dataNascimento,
    });
    return response.data;
  }

  async escolas() {
    const response = await Axios().get("publico/pre-matriculas/escolas");
    return response.data;
  }

  async turmasDaEscola(escolaId) {
    const response = await Axios().get(`publico/pre-matriculas/escolas/${escolaId}/turmas`);
    return response.data;
  }

  async seriesDaTurma(turmaId) {
    const response = await Axios().get(`publico/pre-matriculas/turmas/${turmaId}/series`);
    return response.data;
  }

  async sexos() {
    const response = await Axios().get("publico/pre-matriculas/sexos");
    return response.data;
  }

  async estados() {
    const response = await Axios().get("publico/pre-matriculas/estados");
    return response.data;
  }

  async enviarCodigo(dados) {
    const response = await Axios().post("publico/pre-matriculas/codigo", dados);
    return response.data;
  }

  async gravar(dados) {
    const response = await Axios().post("publico/pre-matriculas", dados);
    return response.data;
  }
}

export default new PreMatriculasService();
